import * as d3 from 'd3';

function createBackgoundDots (colorPattern) {
    const viewBoxWidth = 5200
    const viewBoxHeight = 2420
    let dotColor = colorPattern
    let dotRadius = 1.3
    let botSpacing = 16

    let svg = d3.select("#svg-tree-grid")
    const pattern = svg.append('defs')
        .append('pattern')
        .attr('id', 'dots')
        .attr('patternUnits', 'userSpaceOnUse')
        .attr('width', botSpacing)
        .attr('height', botSpacing)

    pattern.append('circle')
        .attr('cx', dotRadius)
        .attr('cy', dotRadius + 1)
        .attr('r', dotRadius)
        .attr('fill', dotColor)

    svg.append('rect')
        .attr('x', 0)
        .attr('width', viewBoxWidth)
        .attr('height', viewBoxHeight)
        .attr('fill', 'url(#dots)')
}

export default createBackgoundDots
